import StaffCardBase from './staff-card-base';
import {setFrame, delFrame} from './lib/frames';
import 'element-closest/browser';

// http://ejohn.org/blog/comparing-document-position/
const contains = (a, b) => {
    return typeof a.contains === 'function' ?
        a !== b && a.contains(b) :
        (a.compareDocumentPosition(b) & 16) > 0;
};

let isConnected = node => contains(document.body, node);

if (typeof window.Node === 'function' && 'isConnected' in window.Node.prototype) {
    isConnected = node => node.isConnected;
}

class StaffCard extends StaffCardBase {

    constructor(...args) {
        super(...args);
        this._checkAnchorFrame = null;
    }
    /**
     * Включить слежение за якорным элементом
     * @private
     * */
    _startCheckAnchor() {
        const onTick = () => {
            if (isConnected(this.element)) {
                this._checkAnchorFrame = setFrame(onTick);
            } else {
                this.destruct();
            }
        };

        this._stopCheckAnchor();

        onTick();
    }
    /**
     * Прекратить слежение за якорным элементом
     * @private
     * */
    _stopCheckAnchor() {
        delFrame(this._checkAnchorFrame);
        this._checkAnchorFrame = null;
    }
    /**
     * @inheritdoc
     * */
    _delPopup() {
        this._stopCheckAnchor();

        return super._delPopup();
    }
    /**
     * @inheritdoc
     * */
    _createPopup() {
        const result = super._createPopup();

        this._startCheckAnchor();

        return result;
    }

}

export default StaffCard;



// WEBPACK FOOTER //
// ./src/staff-card.js